import { render, staticRenderFns } from "./Firma.vue?vue&type=template&id=4e1d38fd&scoped=true"
import script from "./Firma.vue?vue&type=script&lang=js"
export * from "./Firma.vue?vue&type=script&lang=js"
import style0 from "./Firma.vue?vue&type=style&index=0&id=4e1d38fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d38fd",
  null
  
)

export default component.exports